import './index.css'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router'
import { Provider } from 'react-redux'
import { createStore } from './redux/store.tsx'
import * as Sentry from '@sentry/react'

const preloadedState = (window as any).__PRELOADED_STATE__
delete (window as any).__PRELOADED_STATE__

const store = createStore(preloadedState)

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['www.kbw.de/anmeldung'],
})

ReactDOM.hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <BrowserRouter
    basename={'/video'}  >
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
)
